<template>
  <div class="h-sticky h-sticky--blog">
    <header-partial :headerLang="headerLang" :headerType="headerType"/>
  </div>
</template>

<script>
import HeaderPartial from "./components/HeaderPartial";

export default {
  name: "HeaderBlog",
  components: {
    HeaderPartial
  },
  props: {
    headerLang: {
      type: String,
      default: "es-ES",
    },
    headerType: {
      type: String,
      default: "",
    },
  },
}
</script>